/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const EmailAddress16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8 1a7 7 0 016.996 6.76L15 8v.5a2.5 2.5 0 01-4.62 1.325 3 3 0 11-.38-4.06V5.5a.5.5 0 01.992-.09L11 5.5v3a1.5 1.5 0 002.993.144L14 8.5V8a6 6 0 10-2.787 5.068.5.5 0 01.536.844A7 7 0 118 1zm0 5a2 2 0 100 4 2 2 0 000-4z"
        />
    </AccessibleSVG>
);

export default EmailAddress16;
